export class EksternBrugerPasswordResetPublicModel {
    public passwordResetTokenPublicId: string;
    public password: string;
    public passwordConfirmed: string;
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/models/EksternBrugerPasswordResetPublicModel.ts